import { jsx } from "react/jsx-runtime";
import { createContext, useReducer, useEffect } from "react";
import { noOp } from "../../utils/noOp.js";
import { a as isObject, r as root } from "../../isObject-ec23ace2.js";
import { i as isSymbol } from "../../isSymbol-c6f5cd95.js";
var reWhitespace = /\s/;
function trimmedEndIndex(string) {
  for (var index = string.length; index-- && reWhitespace.test(string.charAt(index)); )
    ;
  return index;
}
var reTrimStart = /^\s+/;
function baseTrim(string) {
  return string && string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "");
}
var NAN = 0 / 0, reIsBadHex = /^[-+]0x[0-9a-f]+$/i, reIsBinary = /^0b[01]+$/i, reIsOctal = /^0o[0-7]+$/i, freeParseInt = parseInt;
function toNumber(value) {
  if (typeof value == "number")
    return value;
  if (isSymbol(value))
    return NAN;
  if (isObject(value)) {
    var other = typeof value.valueOf == "function" ? value.valueOf() : value;
    value = isObject(other) ? other + "" : other;
  }
  if (typeof value != "string")
    return value === 0 ? value : +value;
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
var now = function() {
  return root.Date.now();
};
const now$1 = now;
var FUNC_ERROR_TEXT = "Expected a function", nativeMax = Math.max, nativeMin = Math.min;
function debounce(func, wait, options) {
  var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = !1, maxing = !1, trailing = !0;
  if (typeof func != "function")
    throw new TypeError(FUNC_ERROR_TEXT);
  wait = toNumber(wait) || 0, isObject(options) && (leading = !!options.leading, maxing = "maxWait" in options, maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait, trailing = "trailing" in options ? !!options.trailing : trailing);
  function invokeFunc(time) {
    var args = lastArgs, thisArg = lastThis;
    return lastArgs = lastThis = void 0, lastInvokeTime = time, result = func.apply(thisArg, args), result;
  }
  function leadingEdge(time) {
    return lastInvokeTime = time, timerId = setTimeout(timerExpired, wait), leading ? invokeFunc(time) : result;
  }
  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }
  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
    return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time = now$1();
    if (shouldInvoke(time))
      return trailingEdge(time);
    timerId = setTimeout(timerExpired, remainingWait(time));
  }
  function trailingEdge(time) {
    return timerId = void 0, trailing && lastArgs ? invokeFunc(time) : (lastArgs = lastThis = void 0, result);
  }
  function cancel() {
    timerId !== void 0 && clearTimeout(timerId), lastInvokeTime = 0, lastArgs = lastCallTime = lastThis = timerId = void 0;
  }
  function flush() {
    return timerId === void 0 ? result : trailingEdge(now$1());
  }
  function debounced() {
    var time = now$1(), isInvoking = shouldInvoke(time);
    if (lastArgs = arguments, lastThis = this, lastCallTime = time, isInvoking) {
      if (timerId === void 0)
        return leadingEdge(lastCallTime);
      if (maxing)
        return clearTimeout(timerId), timerId = setTimeout(timerExpired, wait), invokeFunc(lastCallTime);
    }
    return timerId === void 0 && (timerId = setTimeout(timerExpired, wait)), result;
  }
  return debounced.cancel = cancel, debounced.flush = flush, debounced;
}
const initialState = {
  windowWidth: (window == null ? void 0 : window.innerWidth) ?? 0,
  windowHeight: (window == null ? void 0 : window.innerHeight) ?? 0
}, WindowSizeContext = createContext({
  state: initialState,
  dispatch: noOp
});
function WindowSizeContextProvider(props) {
  const [state, dispatch] = useReducer(reducer, initialState);
  function onResize() {
    window && dispatch({
      type: 0,
      payload: { windowWidth: window.innerWidth, windowHeight: window.innerHeight }
    });
  }
  const handleResize = debounce(onResize, props.debounceMs ?? 0);
  return useEffect(
    () => (window.addEventListener("resize", handleResize, { passive: !0 }), handleResize(), function() {
      window.removeEventListener("resize", handleResize);
    }),
    /* eslint-disable-next-line react-hooks/exhaustive-deps --
     *   should only fire on initial render
     */
    []
  ), /* @__PURE__ */ jsx(WindowSizeContext.Provider, { value: { state, dispatch }, children: props.children });
}
function reducer(state, action) {
  switch (action.type) {
    case 0:
      return {
        ...state,
        ...action.payload
      };
    default:
      return state;
  }
}
export {
  WindowSizeContext,
  WindowSizeContextProvider
};
//# sourceMappingURL=WindowSizeContext.js.map
